<app-perfil-crezcamos-endeudamiento-consulta
    *ngIf="informacionPerfil && informacionPerfil.endeudamientoUltimaConsulta"
    [informacionPerfil]="informacionPerfil"
/>
<app-perfil-crezcamos-total-garantias
    *ngIf="informacionPerfil && informacionPerfil.listadoGarantiasDTO"
    [informacionPerfil]="informacionPerfil"
/>
<div *ngIf="informacionPerfil && (informacionPerfil.vectoresPagos || informacionPerfil.creditosVigentes)">
    <div class="titulo-sub-seccion">
        <p>{{ 'PERFILCREZCAMOS.LBL_RESUMENOBLIGACIONESCREZCAMOS' | translate}}</p>
    </div>
    <div class="grid">
        <div class="col-6">
            <app-vactores-pago
                *ngIf="informacionPerfil && informacionPerfil.vectoresPagos"
                [informacionPerfil]="informacionPerfil"
            />
        </div>
        <div class="col-6">
            <app-vectores-pago-crezcamos
                *ngIf="informacionPerfil && informacionPerfil.creditosVigentes"
                [informacionPerfil]="informacionPerfil"
            />
        </div>
    </div>
</div>

<app-perfil-crezcamos-creditos-vigentes
    *ngIf="informacionPerfil && informacionPerfil.obligacionesVigentes"
    [informacionPerfil]="informacionPerfil"
/>

<div *ngIf="informacionPerfil && informacionPerfil.vectoresPagos">
    <div class="titulo-sub-seccion">
        <p>{{ 'PERFILCREZCAMOS.LBL_RESUMENOBLIGACIONESCERRADASCREZCAMOS' | translate}}</p>
    </div>
    <div class="grid">
        <div class="col-12">
            <app-perfil-crezcamos-creditos-cerrados
                *ngIf="informacionPerfil && informacionPerfil.vectoresPagos"
                [informacionPerfil]="informacionPerfil"
            />
        </div>
    </div>
</div>

<ng-container *ngIf="informacionPerfil &&
                    !informacionPerfil.endeudamientoUltimaConsulta &&
                    !informacionPerfil.listadoGarantiasDTO &&
                    !informacionPerfil.vectoresPagos &&
                    !informacionPerfil.creditosVigentes &&
                    !informacionPerfil.obligacionesVigentes">
    <div class="no-hay-informacion">
      <label>{{ "PERFILCREZCAMOS.LBL_NOHAYINFORMACIONPARAMOSTRAR" | translate }}</label>
    </div>
</ng-container>